import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()((theme) => {
    return {
        red: {
            color: theme.palette.common.red,
        },
        grey: {
            color: theme.palette.secondary[900],
        },
    }
})

export default useStyles
